/**
 * Alpine.js component for managing quantity selection and updating cart items.
 * Features include:
 * - Defining states for the quantity selector.
 * - Handling quantity increment and decrement operations.
 * - Posting new quantity to the cart and updating the final price.
 * - Displaying alerts for errors during quantity update.
 */

const STATES = {
  IDLE: 'idle',
  POSTING_INCREMENT: 'posting-increment',
  POSTING_DECREMENT: 'posting-decrement',
};

const quantitySelector = () => ({
  max: 20,
  states: STATES,
  state: STATES.IDLE,

  async postNewQuantity(newQty) {
    try {
      await this.$store.cart.changeLineItem({
        id: this.cartItem.key,
        quantity: newQty,
      });
      this.$nextTick(() => {
        this.updateFinalPrice();
      });
    } catch (error) {
      alert(error.message);
    } finally {
      this.state = STATES.IDLE;
    }
  },

  increment() {
    if (this.state !== STATES.IDLE) return;
    if (this.cartItem.quantity === this.max) return;

    const newQty = this.cartItem.quantity + 1;
    this.state = STATES.POSTING_INCREMENT;
    this.postNewQuantity(newQty);
  },

  async decrement() {
    if (this.state !== STATES.IDLE) return;
    const newQty = this.cartItem.quantity - 1;
    this.state = STATES.POSTING_DECREMENT;
    await this.postNewQuantity(newQty);
    window.dispatchEvent(new CustomEvent('cart-items-changed'));
  },
});

document.addEventListener('alpine:init', () => {
  Alpine.data('quantitySelector', quantitySelector);
});
